var map = {
	"./hp.svg": 280,
	"./print-os.svg": 281
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 583;



//////////////////
// WEBPACK FOOTER
// ./images ../~/html-loader!\.svg$
// module id = 583
// module chunks = 0